import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom"
import Navbar from "./components/Navbar"
import CalendarPage from "./pages/CalendarPage"
import PaymentsPage from "./pages/PaymentsPage"
import TagsPage from "./pages/TagsPage"
import CreateTagPage from "./pages/CreateTagPage"
import EditTagPage from "./pages/EditTagPage"
import LoginPage from "./pages/LoginPage"
import RegisterPage from "./pages/RegisterPage"
import { AppProvider, useAppContext } from "./context/AppContext"
import { AuthProvider } from "./context/AuthContext"
import ProtectedRoute from "./components/ProtectedRoute"
import "./App.css"
import { ObservationProvider } from "./context/ObservationContext"
import { AiOutlineLoading } from "react-icons/ai"

function App() {
  console.log("oi");
  

  return (
    <AuthProvider>
      <AppProvider>
        <ObservationProvider>
          <Router>
            <div className="app">
              <Navbar />
              <main className="main-content">
                <Routes>
                  {/* Public routes */}
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<RegisterPage />} />

                  {/* Protected routes */}
                  <Route
                    path="/"
                    element={
                      <ProtectedRoute>
                        <CalendarPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/payments"
                    element={
                      <ProtectedRoute>
                        <PaymentsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tags"
                    element={
                      <ProtectedRoute>
                        <TagsPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tags/new"
                    element={
                      <ProtectedRoute>
                        <CreateTagPage />
                      </ProtectedRoute>
                    }
                  />
                  <Route
                    path="/tags/edit/:id"
                    element={
                      <ProtectedRoute>
                        <EditTagPage />
                      </ProtectedRoute>
                    }
                  />

                  {/* Redirect any unknown routes to home */}
                  <Route path="*" element={<Navigate to="/" replace />} />
                </Routes>
              </main>
            </div>
          </Router>
        </ObservationProvider>
      </AppProvider>
    </AuthProvider>
  )
}

export default App

